module.exports = __webpack_public_path__ + "static/media/Bogdan.aa215a4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Bogdan.jpg
// module id = 848
// module chunks = 0